import JSZip from "jszip";
import { saveAs } from "file-saver";

export const downloadAllAsZip = async (documents: any[], uid?: string) => {
  const zip = new JSZip();

  const downloads = documents?.map(async (doc) => {
    const res = await fetch(doc?.previewUrl);
    const blob = await res.blob();
    zip.file(doc.title, blob);
  });

  await Promise.all(downloads);

  const zipBlob = await zip.generateAsync({ type: "blob" });

  const fileName = uid
    ? `auction-documents-${uid}.zip`
    : "auction-documents.zip";
  saveAs(zipBlob, fileName);
};
